<template>
  <section class="leftAsideElMainFrom">
    <leftAside
      v-if="$route.meta.showLeftAside && showRouter"
      :menuData="menuData"
      :muneTitle="muneTitle"
      :acColor="acColor"
      :iconClass="iconClass"
    ></leftAside>
    <section
      v-if="showRouter"
      class="leftAsideElMainSe"
      :style="{ width: rightMianWidth + 'px' }"
    >
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </section>
  </section>
</template>
<script>
import leftAside from "@/components/pcFrom/leftAside.vue";
import { mapGetters } from "vuex";
import { menuData } from "@/views/rhqy/config/menuDataYy.js";

export default {
  props: {},
  data() {
    return {
      menuData: [],
      muneTitle: menuData.menuName,
      iconClass: menuData.iconClass,
      acColor: "red",
      redirectMenu: {},
      showRouter: false
    };
  },
  watch: {
    $route(to, from) {
      const toArr = to.path.split("/");
      const fromArr = from.path.split("/");
      if (toArr[2] != fromArr[2]) {
        // this.getMenuData();
      }
    }
  },
  components: {
    leftAside
  },
  computed: {
    ...mapGetters(["rightMianWidth"])
  },
  async mounted() {},
  methods: {
    // 获取左菜单数据
    getMenuData() {
      if (!this.$route.meta.showLeftAside) {
        return;
      }
      // 访问菜单第一个有权限的页面
      if (this.$route.path == "/rhqy/yyManege") {
        for (let i = 0; i < this.menuData.length; i++) {
          if (
            !this.menuData[i].children ||
            this.menuData[i].children.length == 0
          ) {
            // 记录第一个有权限的菜单
            this.redirectMenu = this.menuData[i];
            break;
          }
        }
        this.$router.push(this.redirectMenu.path);
      }
    },
    getClassifly() {
      return this.$common.http({
        method: "get",
        url: "/api/app/list_top_category"
      });
    }
  },
  async created() {
    const classifly = await this.getClassifly();
    const menuData = classifly.data.data;
    menuData.forEach(element => {
      let iconClass = "el-icon-s-grid";
      if (element.name == "车辆预约") {
        iconClass = "el-icon-time";
      }
      if (element.name == "综合类应用") {
        iconClass = "icon-rh-app";
      }
      this.menuData.push({
        path: "/rhqy/yyManege/carAppoint/" + element.id,
        menuName: element.name,
        privilege: "",
        iconClass: iconClass
      });
    });
    this.showRouter = true;
    this.getMenuData();
    console.log(menuData);
  }
};
</script>
<style lang="less" scope>
.leftAsideElMainFrom {
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  .leftAsideElMainSe {
    width: 100%;
    height: 100%;
  }
}
</style>
